enum StatutControleCoherence {
	ERROR = 0,
	WARNING = 1,
	OK = 2,
}

export default StatutControleCoherence;
